import * as api from '../api';
// ACtion creators 
//import { FETCH_ALL, CREATE, UPDATE, DELETE, LIKE } from '../constants/actionTypes';

export const getPosts = () => async(dispatch)=>{ 
    try{
      const { data } = await api.fetchPosts();
      dispatch({ type: 'FETCH_ALL' , payload: data});
    }catch(error) {
      console.log(error);
    }
}

export const createPost = (post) => async (dispatch) =>{
  try{
   const {data} = await api.createPost(post);

   dispatch({type:'CREATE',payload:data});
  }catch(error){
    console.log(error);
  }

}

export const deletePost = (id) => async (dispatch) => {
  try {
    await api.deletePost(id);

    dispatch({ type: 'DELETE', payload: id });
  } catch (error) {
    console.log(error.message);
  }
};